<template>
  <a-modal
    title="退出登录"
    visible
    :width="460"
    @cancel="$emit('close')"
    class="action"
  >
    <template slot="footer">
      <a-button type="primary" @click="create" class="sure">确定</a-button>
      <a-button @click="$emit('close')" class="qu">取消</a-button>
    </template>
    <div class="login">
      <div>确定要退出登录吗?</div>
    </div>
  </a-modal>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  props: ['visibles'],
  data() {
    return {}
  },
  methods: {
    create() {
      this.$http.get('sys/loginOut').then((res) => {
        if (res.data.code == 0) {
          // this.visibles = false
          sessionStorage.clear()
          Cookies.remove('token')
          this.$router.push({ path: '/login' })
        } else if (res.data.code == 600) {
          this.$message.info('请登录')
        } else {
          this.$message.info(res.data.msg)
        }
      })

      // $http.post('/logout').then((res) => {
      //   if (res.code == 200) {
      //     this.$router.push({ path: '/login' })

      //     sessionStorage.clear()
      //   } else {
      //     this.$message.info(res.message)
      //   }
      // })
    },
  },
}
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  color: #252631;
  text-align: center;
  font-size: 14px;
}
.smart-form-inline {
  .ant-form-item {
    display: flex;

    margin-bottom: 12px;
  }
  .ant-form-item-label {
    min-width: 90px;
  }
  .ant-form-item-control-wrapper {
    flex: 1;
  }
}
.sure.ant-btn-primary {
  border-radius: 16px !important;
  background: #5575e9;
  border: none;
}
.qu.ant-btn {
  border-radius: 16px;

  color: #384c6d;
  background: #ffffff;
  border: 1px solid #e2e9ee;
}
.iconfont {
  cursor: pointer;
}
</style>
